//@ts-ignore-next-line
import PostalMime from "postal-mime";

export interface EmlAttachment {
  filename: string;
  mimeType: string;
  size: number;
  content: Uint8Array;
}

export interface ParsedEml {
  from?: string;
  to?: string;
  cc?: string;
  date?: string;
  subject?: string;
  html?: string;
  text?: string;
  attachments: EmlAttachment[];
}

const toBytes = (content: ArrayBuffer | Uint8Array | string | undefined): Uint8Array => {
  if (content instanceof ArrayBuffer) return new Uint8Array(content);
  if (typeof content === "string") return new TextEncoder().encode(content);
  if (content instanceof Uint8Array) return content;
  return new Uint8Array(0);
};

const formatAddress = (addr?: { name?: string; address?: string }): string => {
  if (!addr) return "";
  const name = (addr.name || "").trim();
  const address = (addr.address || "").trim();
  if (name && address) return `${name} <${address}>`;
  return name || address || "";
};

const joinAddresses = (list?: { name?: string; address?: string }[]): string | undefined => {
  const joined = (list ?? []).map(formatAddress).filter(Boolean).join(", ");
  return joined || undefined;
};

export async function parseEml(input: ArrayBuffer | Uint8Array): Promise<ParsedEml> {
  const buffer = input instanceof Uint8Array ? input.buffer : input;
  const mail = await PostalMime.parse(buffer as ArrayBuffer);

  const attachments: EmlAttachment[] = (mail.attachments ?? []).map((a: any) => {
    const content = toBytes(a.content);
    return {
      filename: a?.filename || "attachment",
      mimeType: a?.mimeType || "application/octet-stream",
      size: content.byteLength,
      content,
    };
  });

  return {
    from: formatAddress(mail.from) || undefined,
    to: joinAddresses(mail.to),
    cc: joinAddresses(mail.cc),
    date: mail.date ?? undefined,
    subject: mail.subject ?? undefined,
    html: mail.html ?? undefined,
    text: mail.text ?? undefined,
    attachments,
  };
}
